import React, { useEffect } from 'react'
import './App.css'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { Box } from '@mui/material'
import Grid from '@mui/material/Grid'
import styled from 'styled-components'
import { useActions, useAppSelector } from './hooks'
import { tool } from './store/AIMetricOT/reducerSlice'
import AIMetricOvertime from './components/Chart/AIMetricOvertime'
import LeftPanel from './components/common/LeftPanel/LeftPanel'
import GlobalNationalVibrancyRanking from './components/GlobalNationalVibrancyRanking/GlobalNationalVibrancyRanking'
import MethodologyAndMetrics from 'components/MethodologyAndMetrics/MethodologyAndMetrics'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import MobileViewInfo from 'components/common/MobileViewInfo'

function App() {
  const { loadCountryData, loadMetricData, loadMetricDataTypeMap, loadLegendData, loadLegendYearData } = useActions()
  const currentTool = useAppSelector(tool)
  const showDwnLoader = useAppSelector(({ vibrancy }) => vibrancy.showDwnLoader)

  const theme = createTheme({
    typography: {
      fontFamily: ['CircularStdBook'].join(','),
    },
  })

  useEffect(() => {
    loadCountryData()
    loadMetricData()
    loadMetricDataTypeMap()
    loadLegendData()
    loadLegendYearData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{ padding: { xs: '8px 0px', md: '24px', lg: '40px' }, height: '100%', fontSize: '1rem' }}
        className='Appp'
      >
        <Box className='AppContainer'>
          <Grid
            container
            spacing={2}
            sx={{
              width: '100%',
              maxWidth: '1624px',
              display: 'flex',
              justifyContent: { xs: 'flex-start', xl: 'center' },
              flexWrap: { xs: 'flex-start', md: 'nowrap' },
            }}
          >
            <Grid
              item
              xs={12}
              md={5}
              lg={5}
              xl={4}
              sx={{
                width: '100%',
                minWidth: { xs: '360px', sm: '400px', md: '480px', lg: '480px' },
                maxWidth: { lg: '480px' },
              }}
            >
              <GridWrapper>
                <LeftPanel />
              </GridWrapper>
            </Grid>
            <Grid item xs={12} md={7} lg={7} xl={8} sx={{ width: '100%', maxWidth: '980px' }}>
              <Spin
                spinning={showDwnLoader}
                tip={<span style={{ color: '#172e5c' }}>Downloading...</span>}
                indicator={<LoadingOutlined style={{ color: '#172e5c' }} spin />}
                size='large'
              >
                <GridWrapper style={{ display: 'block', padding: '0px', height: '100%' }}>
                  <Box sx={{ height: '100%' }}>
                    {currentTool === 'AIVR' ? <GlobalNationalVibrancyRanking /> : <AIMetricOvertime />}
                  </Box>
                </GridWrapper>
              </Spin>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        sx={{
          padding: { xs: '40px 20px', md: '40px', lg: '40px' },
          height: '100%',
          backgroundColor: 'white',
          fontSize: '1rem',
        }}
        className='Appp'
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'flex-start', xl: 'center' },
            flexWrap: { xs: 'flex-start', md: 'nowrap' },
          }}
        >
          <MethodologyAndMetrics />
        </Box>
        <MobileViewInfo />
      </Box>
    </ThemeProvider>
  )
}
const GridWrapper = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  border: none;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
  height: 100%;
  position: relative;
`

export default App
